var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9542 5.99121H23.223",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6338 6.04688L21.4283 18.0984",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2325 5.99121L24.5614 14.9593",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8629 8.58496H25.6865",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4188 18.4297H5.47192",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9398 21.9982C26.8845 21.9982 28.4609 20.4174 28.4609 18.4673C28.4609 16.5173 26.8845 14.9365 24.9398 14.9365C22.9952 14.9365 21.4187 16.5173 21.4187 18.4673C21.4187 20.4174 22.9952 21.9982 24.9398 21.9982Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6489 18.4688C13.6489 20.4141 12.0775 21.9996 10.1277 21.9996C8.17804 21.9996 6.60663 20.4238 6.60663 18.4688",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56694 9.97783H3.38621C2.06701 9.97783 1 8.90788 1 7.58504V3.39279C1 2.06995 2.06701 1 3.38621 1H7.56694C8.88614 1 9.95315 2.06995 9.95315 3.39279V7.58504C9.95315 8.90788 8.88614 9.97783 7.56694 9.97783Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4143 18.4302L13.1348 13.6641",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47179 18.43C5.47179 18.43 5.35539 13.6055 9.73982 13.6055",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3587 13.6154H3.90027V9.97754H12.3587C13.3578 9.97754 14.1726 10.7946 14.1726 11.7964C14.1726 12.7983 13.3578 13.6154 12.3587 13.6154Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/Bicycle.c46005fa644b8e1d0a2ceb6f51cebb0c.svg";
export { ForwardRef as ReactComponent };